
import { COMPONENT_MAP } from '../../utils/landingsData';
import scrollDepth from '../../utils/ladingsMixins/scrollDepth';
import sectionReach from '../../utils/ladingsMixins/sectionReach';

export default {
    name: 'MeatPage',
    mixins: [scrollDepth, sectionReach],
    layout: 'MeatLayout',
    async asyncData({ $axios, env, error, query, params }) {
        const { landing } = params
        const { preview } = query
        try {
            const meatResponse = await $axios.$get(`${env.API_URL_SITE}/landing/${landing}${preview ? `?preview=${preview}` : ""}`);
            return { meatData: meatResponse.data };
        } catch (e) {
            console.error('Failed to fetch data:', e);
            return error({ statusCode: 404, message: 'Page not found' })
        }
    },
    data() {
        return {
            meatData: null
        };
    },
    head() {
        return {
            bodyAttrs: {
                class: 'meat-page-body'
            },
            script: [
                {
                    hid: 'yandex-metrika',
                    src: '/meat/lib/yandex-metrika.js',
                    type: 'text/javascript',
                    charset: 'utf-8'
                }
            ],
            noscript: [
                {
                    hid: 'yandex-metrika-noscript',
                    innerHTML: '<div><img src="https://mc.yandex.ru/watch/25259228" style="position:absolute; left:-9999px;" alt="" /></div>'
                }
            ],
            ...(this.pageData ? this.pageData.head : {})
        }
    },
    computed: {
        pageData() {
            if (!this.meatData) return null;
            return this.meatData[this.$i18n.locale];
        },
        sortedBlocks() {
            if (!this.pageData || !this.pageData.blocks) return [];

            return Object.entries(this.pageData.blocks)
                .map(([key, blockData]) => ({
                    key,
                    ...blockData
                }))
                .sort((a, b) => (a.sort || 0) - (b.sort || 0)); 
        }
    },
    methods: {
        getComponent(key) {
            return COMPONENT_MAP[key] || null;
        }
    }
}
